module.exports = __webpack_public_path__ + "img/teacher-portal-logo.c34e9d2b.png";